import React from 'react';
import { Button, Table, Tooltip,Empty } from 'antd';

export default class ResultList2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Table
                className={'logistica-table-kardex-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
                onExpand={async (expanded, record) => {
                    await this.props.handleSearchNivel1(record);
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Elemento',
                        dataIndex: 'elemento',
                        key: 'elemento',
                        align: "center"
                    },
                    {
                        title: 'Código Cuenta',
                        dataIndex: 'codigoCuenta',
                        key: 'codigoCuenta',
                        align: "center"
                    },
                    {
                        title: 'Descripción',
                        dataIndex: 'descripcion',
                        key: 'descripcion',
                        align: "center"
                    },
                    {
                        title: 'Tipo Cuenta',
                        dataIndex: 'tipoCuenta',
                        key: 'tipoCuenta',
                        align: "center"
                    },
                    {
                        title: 'OP. Asociada',
                        dataIndex: 'OperacionAsociada',
                        key: 'OperacionAsociada',
                        align: "center"
                    },
               
                ]}
            />
        );
    }
}